import {Lender} from './lenders/lender';
import {
  useInfiniteData,
  UseInfiniteDataProps,
} from '@common/ui/infinite-scroll/use-infinite-data';
import {useActiveWorkspaceId} from '@common/workspace/active-workspace-id-context';

interface Params {
  userId?: string | number;
  published?: string;
  paginate?: UseInfiniteDataProps<undefined>['paginate'];
}

export function useLenders(params: Params) {
  const {workspaceId} = useActiveWorkspaceId();
  return useInfiniteData<Lender>({
    queryKey: ['lenders', {...params, workspaceId}],
    endpoint: 'lenders',
    paginate: params.paginate || 'simple',
    defaultOrderBy: 'updated_at',
    defaultOrderDir: 'desc',
    queryParams: {
      ...params,
      workspaceId,
    },
    willSortOrFilter: true,
  });
}
